import {transformYearMonthDayToDateMonthYear} from '../dateUtils/dateFormattingUtils';

import {APPLICANT_JOB_SEARCH_STATUS} from '../../lib/constants';

export const isValidDate = (dateString: string): boolean => {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};

export const getStartDateDisplay = (
  startDate: string | undefined,
  t: (key: string) => string,
  prefix?: string
): string => {
  if (startDate && isValidDate(startDate)) {
    return transformYearMonthDayToDateMonthYear(startDate);
  } else {
    return prefix ? t(`${prefix}.notSpecified`) : t('shared.notSpecified');
  }
};

export const hasLeadershipExperience = (
  leadershipExperience: boolean | undefined,
  t: (key: string) => string
): string => {
  return leadershipExperience ? t('shared.yes') : t('shared.no');
};

export const getHighestDegreeDisplay = (
  highestDegree: string | undefined,
  t: (key: string) => string,
  prefix?: string
): string => {
  if (!highestDegree) {
    return prefix ? t(`${prefix}.notSpecified`) : t('shared.notSpecified');
  }

  return highestDegree;
};

type Language = 'en' | 'de';

export const applicantJobSearchStatus = (currentLanguage: Language) => {
  return APPLICANT_JOB_SEARCH_STATUS.map((status) => {
    return {
      id: status.id,
      label: status.label[currentLanguage],
    };
  });
};
